import React from 'react'
import { Link } from 'react-router-dom'

const ChannelName = ({ channelDetail }) => {

  return (
    <>
   <div className="card h-100  "  id="cardWidthSet" >
        <Link to={ `channel/${channelDetail?.id?.channelId}` } className=' text-decoration-none '>
        <img src={channelDetail?.snippet?.thumbnails?.high?.url} className="card-img-top" alt="images" height={'170px'} width={'300px'} />
        
          <h4 className="card-text link-dark py-0 ms-1 fw-bold text-center">{channelDetail?.snippet?.title} </h4>
          {
            channelDetail?.statistics?.subscriberCount && (
              <p>
                {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString()}
              </p>
            )
          }
        
        </Link>

       
     
      </div>
    </>
  )
}

export default ChannelName